webpackJsonp([32],{

/***/ 1108:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="36" height="45" viewBox="0 0 36 45" xmlns="http://www.w3.org/2000/svg"><path d="M17 9.5l-17 17 17.607 17.607 17.5-17.5L26 17.5V0l-9 9.5z"/></svg>'};

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon_single_quote_blue = __webpack_require__(1108);

var _icon_single_quote_blue2 = _interopRequireDefault(_icon_single_quote_blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'quoteBlock',
  components: {
    SingleQuoteSvg: _icon_single_quote_blue2.default
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    quoteType: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    mainClassName: function mainClassName() {
      switch (this.quoteType) {
        case 'default':
          return 'blockquote-quote';
        case 'author':
          return 'blockquote-author';
        default:
          {
            return 'blockquote-quote';
          }
      }
    }
  }
};

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".quote[data-v-3c593d01]{position:relative;background-color:#fff}.quote-container[data-v-3c593d01]{font-family:Barlow,sans-serif}.blockquote-quote[data-v-3c593d01]{font-size:1.625rem;line-height:2.0625rem;font-style:italic;-o-border-image:-o-linear-gradient(left,#f8008e,#00e8ff);border-image:-webkit-gradient(linear,left top,right top,from(#f8008e),to(#00e8ff));border-image:linear-gradient(90deg,#f8008e,#00e8ff);border-image-slice:1;border-style:solid;border-width:.1875rem 0 0;margin-top:3.125rem;padding:1.25rem .625rem;color:#f8008e;font-family:Barlow,sans-serif;font-weight:700}.blockquote-quote .quotes[data-v-3c593d01]{position:absolute;top:-2.0625rem;left:.625rem;width:5rem;height:2.75rem}.blockquote-quote .quotes__icon[data-v-3c593d01]{display:inline-block;position:relative;width:2.1875rem;margin-right:.1875rem}.blockquote-quote .quotes__icon:first-child svg[data-v-3c593d01]{fill:#76ffff;-webkit-animation:quoteFlickering 1s step-start infinite alternate;animation:quoteFlickering 1s step-start infinite alternate}.blockquote-quote .quotes__icon:last-child svg[data-v-3c593d01]{fill:#18ffff;-webkit-animation:quoteFlickeringReverse 1s step-start infinite alternate;animation:quoteFlickeringReverse 1s step-start infinite alternate}.blockquote-author[data-v-3c593d01]{color:#00cbcc;padding:0 .625rem 1.25rem;text-transform:uppercase;z-index:2}@media (min-width:1024px){.blockquote-author[data-v-3c593d01]{font-size:.875rem;line-height:1.3125rem;font-weight:400}}@media (min-width:0) and (max-width:1023px){.blockquote-author[data-v-3c593d01]{font-size:.875rem;line-height:1rem}}.blockquote-author .quotes[data-v-3c593d01]{display:none}", "", {"version":3,"sources":["/app/components/node/QuoteBlock.vue"],"names":[],"mappings":"AAgCA,wBACE,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,kCACE,6BAAkC,CACnC,AACD,mCACE,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,yDAA4D,AACzD,mFAAwF,AACxF,oDAA0D,AAC7D,qBAAsB,AACtB,mBAAoB,AACpB,0BAA8B,AAC9B,oBAAqB,AACrB,wBAA0B,AAC1B,cAAe,AACf,8BAAkC,AAClC,eAAkB,CACnB,AACD,2CACI,kBAAmB,AACnB,eAAgB,AAChB,aAAe,AACf,WAAY,AACZ,cAAgB,CACnB,AACD,iDACM,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,CAC7B,AACD,iEACQ,aAAc,AACd,mEAAoE,AAC5D,0DAA4D,CAC3E,AACD,gEACQ,aAAc,AACd,0EAA2E,AACnE,iEAAmE,CAClF,AACD,oCAGE,cAAe,AACf,0BAA4B,AAC5B,yBAA0B,AAC1B,SAAW,CACZ,AACD,0BACA,oCACM,kBAAoB,AACpB,sBAAuB,AACvB,eAAqB,CAC1B,CACA,AACD,4CACA,oCACM,kBAAoB,AACpB,gBAAkB,CACvB,CACA,AACD,4CACI,YAAc,CACjB","file":"QuoteBlock.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.quote[data-v-3c593d01] {\n  position: relative;\n  background-color: #FFFFFF;\n}\n.quote-container[data-v-3c593d01] {\n  font-family: \"Barlow\", sans-serif;\n}\n.blockquote-quote[data-v-3c593d01] {\n  font-size: 1.625rem;\n  line-height: 2.0625rem;\n  font-style: italic;\n  -o-border-image: -o-linear-gradient(left, #F8008E, #00E8FF);\n     border-image: -webkit-gradient(linear, left top, right top, from(#F8008E), to(#00E8FF));\n     border-image: linear-gradient(to right, #F8008E, #00E8FF);\n  border-image-slice: 1;\n  border-style: solid;\n  border-width: 0.1875rem 0 0 0;\n  margin-top: 3.125rem;\n  padding: 1.25rem 0.625rem;\n  color: #F8008E;\n  font-family: \"Barlow\", sans-serif;\n  font-weight: bold;\n}\n.blockquote-quote .quotes[data-v-3c593d01] {\n    position: absolute;\n    top: -2.0625rem;\n    left: 0.625rem;\n    width: 5rem;\n    height: 2.75rem;\n}\n.blockquote-quote .quotes__icon[data-v-3c593d01] {\n      display: inline-block;\n      position: relative;\n      width: 2.1875rem;\n      margin-right: 0.1875rem;\n}\n.blockquote-quote .quotes__icon:first-child svg[data-v-3c593d01] {\n        fill: #76FFFF;\n        -webkit-animation: quoteFlickering 1s step-start infinite alternate;\n                animation: quoteFlickering 1s step-start infinite alternate;\n}\n.blockquote-quote .quotes__icon:last-child svg[data-v-3c593d01] {\n        fill: #18FFFF;\n        -webkit-animation: quoteFlickeringReverse 1s step-start infinite alternate;\n                animation: quoteFlickeringReverse 1s step-start infinite alternate;\n}\n.blockquote-author[data-v-3c593d01] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n  color: #00CBCC;\n  padding: 0 0.625rem 1.25rem;\n  text-transform: uppercase;\n  z-index: 2;\n}\n@media (min-width: 1024px) {\n.blockquote-author[data-v-3c593d01] {\n      font-size: 0.875rem;\n      line-height: 1.3125rem;\n      font-weight: initial;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.blockquote-author[data-v-3c593d01] {\n      font-size: 0.875rem;\n      line-height: 1rem;\n}\n}\n.blockquote-author .quotes[data-v-3c593d01] {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("471850d8", content, true, {});

/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1130),
  /* template */
  __webpack_require__(1174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c593d01",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.mainClassName, 'quote']
  }, [_c('div', {
    staticClass: "quotes"
  }, [_c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1), _c('div', {
    staticClass: "quotes__icon"
  }, [_c('single-quote-svg')], 1)]), _vm._v("\n  " + _vm._s(_vm.value) + "\n")])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 32.bed89ebcf52c19b4a0be.js